import { createStyles, makeStyles, Theme } from '@material-ui/core'

// eslint-disable-next-line
export const useSystemManagementStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'grid',
      gridTemplateColumns: '256px 1fr',
      gridTemplateRows: '1fr',
      gridTemplateAreas: `"sidebar main"`,
      columnGap: '10px',
      width: '100vw',
      height: '100vh',
    },

    templateSidebar: {
      gridArea: 'sidebar',
      width: '100%',
      height: `calc(100vh - ${theme.spacing(8)}px)`,
    },

    templateMain: {
      gridArea: 'main',
      overflowY: 'auto',
      width: '100%',
      height: `calc(100vh - ${theme.spacing(8)}px)`,
      padding: '8px',
    },

    sidebar: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[4],

      '& > header': {
        height: '60px',
        textAlign: 'center',
        padding: '16px',
        fontSize: '1rem',
        lineHeight: '1.6rem',
      },
      '& ul': {
        padding: 0,
      },
    },
    listItem: {
      padding: '0',

      '& a': {
        padding: '16px',
        width: '100%',
        display: 'block',
        color: theme.palette.primary.main,
        textTransform: 'none',
        textDecoration: 'none',
      },

      '&:hover': {
        background: theme.palette.action.selected,
        color: theme.palette.primary.main,
      },
    },
  })
)
